import styles from "./About.module.css";
import downloadIcon from "../../images/download_icon.png";

export default function LinksList() {
  const linksText = [
    {
      text: ["Risk Assessment &", "Contingency Plan", "Template"],
      link: "risk_assessment",
    },
    { text: ["Event  Budget", "Planner"], link: "event_budget" },
    {
      text: ["Event Purpose &", "Objective", "Worksheet"],
      link: "event_purpose",
    },
    {
      text: ["Technical", "Requirements", "Cheat-Sheet"],
      link: "technical_requirements",
    },
    {
      text: ["End to End", "Event Planing", "Checklist"],
      link: "event_planing",
    },
    { text: ["Event", "Excellence", "Starter Pack"], link: "event_excellence" },
  ];

  return (
    <section className={styles.links_section}>
      <p>Download Our Free Event Production Tools</p>
      <p>
        Maximize the success of your next event with our expert-designed
        templates and worksheets:
      </p>
      <div className={styles.linksList_container}>
        {linksText.map((item, index) => {
          return (
            <div className={styles.link_item}>
              <a
                href={`${window.location.origin}/files/${item.link}.pdf`}
                key={index}
              >
                {item.text.map((text) => {
                  return <p>{text}</p>;
                })}
              </a>

              <img
                className={styles.downloadIcon}
                src={downloadIcon}
                alt="download"
              />
            </div>
          );
        })}
      </div>
      <p>
        Use these resources to streamline planning, reduce risk, and deliver
        outstanding results—just like the pros.
      </p>
    </section>
  );
}
